export default class Header {
	static init() {
		new Header(document.querySelector('.header'));
	}

	constructor(element) {
		if (!element) {
			return;
		}

		window.addEventListener('scroll', () => requestAnimationFrame(() => {
			element.classList[window.scrollY < 10 ? 'remove' : 'add']('header--is-scrolled');
		}));
		element.classList[window.scrollY < 10 ? 'remove' : 'add']('header--is-scrolled');
	}
}